import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["submit"]

  connect() {
    window.onTurnstileSuccess = () => { this.submitTarget.disabled = false }
    window.onTurnstileExpired = () => { this.submitTarget.disabled = true }
    window.onTurnstileError = () => { this.submitTarget.disabled = false }
  }

  disconnect() {
    delete window.onTurnstileSuccess
    delete window.onTurnstileExpired
    delete window.onTurnstileError
  }
}
